import getRemoteConfig from './get-remote-config';

const getFeatureSwitchValue = async featureSwitch => {
  const configValue = await getRemoteConfig(featureSwitch);
  if (!configValue) return null;
  return configValue.asBoolean();
};

export default getFeatureSwitchValue;
